import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import classNames from 'classnames';
import { ReactElement } from 'react';
import { TRAINING_VARIANT } from '../../jobs.model';
import { IJobThreshold } from '../../jobThreshold.store';
import { RecalculateMetricsSlider, SliderWithLabel } from '../SliderWithLabel';

interface IInspectorSettingsProps {
  isReadonly: boolean;
  handleChangeThreshold: (value: number) => void;
  thresholdConfig: null | IJobThreshold;
  variant: TRAINING_VARIANT;
}

export const InspetorSettings = ({ isReadonly, handleChangeThreshold, thresholdConfig, variant }: IInspectorSettingsProps): ReactElement => {
  const { t } = useTranslator();

  if (!thresholdConfig) {
    return <></>;
  }

  return (
    <div className={classNames('predictions-view', { 'annotation-tools-readonly-overlay': isReadonly })}>
      <div className='header'>
        <FontAwesomeIcon icon='cog' /> {t('parameters')}
      </div>
      <div className='predictions-view-inner'>
        {thresholdConfig &&
          ![TRAINING_VARIANT.ANOMALY_DETECTION_7, TRAINING_VARIANT.ANOMALY_DETECTION_8, TRAINING_VARIANT.ANOMALY_DETECTION_4].includes(variant) && (
            <SliderWithLabel
              label={t('threshold.title')}
              min={thresholdConfig.minScore}
              max={thresholdConfig.maxScore}
              step={thresholdConfig.thresholdStep}
              value={thresholdConfig.optimalThreshold}
              onChange={handleChangeThreshold}
              disabled={isReadonly}
            />
          )}
        {thresholdConfig && typeof thresholdConfig.minThreshold === 'number' && typeof thresholdConfig.maxThreshold === 'number' && (
          <RecalculateMetricsSlider
            label={t('threshold.title')}
            min={thresholdConfig.minScore}
            max={thresholdConfig.maxScore}
            step={thresholdConfig.thresholdStep}
            value={[thresholdConfig.minThreshold, thresholdConfig.maxThreshold]}
            inputsValues={{ min: thresholdConfig.minThreshold.toFixed(1), max: thresholdConfig.maxThreshold.toFixed(1) }}
            disabled={isReadonly}
          />
        )}
      </div>
    </div>
  );
};
